import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

const CallToAction = () => {
  return (
    <section
      className="bg-cover bg-center bg-no-repeat py-16 sm:py-20 bg-primary1 rounded-br-[220px] rounded-tl-[200px] md:rounded-br-[150px] md:rounded-tl-[150px] sm:rounded-br-[50px] sm:rounded-tl-[50px]"
      aria-label="Software development call to action section"
    >
      <div className="container mx-auto text-center text-white px-4 sm:px-6 md:px-8">
        <header className="mb-8 sm:px-10 md:px-16 lg:px-28">
          <h3 className="text-3xl sm:text-3xl font-semibold mb-4">
            Let’s Build Your Software Together
          </h3>
          <p className="text-base sm:text-lg leading-relaxed">
            Have an idea for a website, app, or custom software? 
            <br className="hidden sm:block" />
            Our expert team at <strong>ShivayTech Innovations Pvt Ltd</strong> specializes in creating scalable and modern digital solutions for businesses, campaigns, and individuals. 
            <br className="hidden sm:block" />
            Contact us today — we’ll turn your vision into reality!
          </p>
        </header>

        <a
          className="bg-primary2 text-white py-2 px-6 rounded-full hover:bg-white hover:text-primary2 transition-all duration-300"
          href="https://wa.me/919309140606?text=Hello%2C%20I%27m%20interested%20in%20developing%20a%20software%20project%20with%20Yahshua%20Software%20Ltd."
          target="_blank"
          rel="noopener noreferrer"
          role="button"
          aria-label="Contact us on WhatsApp"
        >
          Contact Us <FaArrowRight className="inline ml-2" />
        </a>
      </div>
    </section>
  );
};

export default CallToAction;
